/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any */
import { hall } from '@/hall'
import { ModuleBase } from './ModuleBase'
import { log, bytesToString, stringToBytes } from '@/utils/functions'
import { base } from '@/base/base'
import { serverErrorMsg } from '@/defines/ServerError'
import { EventDefine } from '@/defines/EventDefine'
import { webErrorMsg } from '@/defines/WebError'
import { WebDefine } from '@/defines/WebDefine'
import { FunctionUtils } from '@/utils/FunctionUtils'
import { MsgIDs } from '@/defines/MsgIDs'
import { wsClient } from '@/net/WebSocketClient'

export class UserModule extends ModuleBase {
  public userId: number = 1

  public gold = 0
  public deposit = 0
  public withdraw = 0
  public bonus = 0 // FreeCash
  public diamond = 0

  public phoneNum = ''

  public message_id = '0' //短线返回验证码
  private payed_ = false
  public regaccount = '' //玩家账户名
  public userphone = '' //玩家手机号

  _userName: string = ''

  set userName(value: any) {
    if (typeof value == 'string') {
      this._userName = value
    } else {
      this._userName = bytesToString(value)
    }
  }

  get userName(): string {
    return this._userName
  }

  _userIcon: number = 1

  set userIcon(value: any) {
    if (typeof value == 'string') {
      this._userIcon = this._toIconIndex(value)
    } else {
      this._userIcon = value
    }
  }

  get userIcon(): number {
    return this._userIcon
  }

  _vipLevel: number = 0

  set vipLevel(value: number) {
    this._vipLevel = value
    hall.eventDispatcher.emit(hall.EventDefine.VipLevelChange)
  }

  get vipLevel(): number {
    return this._vipLevel
  }

  private _userInfo: any = null

  setUserInfo(value: any) {
    this._userInfo = value

    this.userId = this._userInfo.UserID
    this.userName = this._userInfo.NickName
    this.userIcon = this._userInfo.HeaderURL
    this.phoneNum = this._userInfo.Mobile

    hall.eventDispatcher.emit(hall.EventDefine.UserInfoChange)

    // base.sdkWrapper.setAccountId(this.userId)
    // base.sdkWrapper.setChannel(base.channelId)
  }

  // HeaderURL: "resources://2"
  _toIconIndex(iconStr: string): number {
    let index = 1
    if (iconStr && iconStr != '') {
      iconStr = iconStr.replace('resources://', '')
      index = parseInt(iconStr)

      if (isNaN(index)) {
        index = 1
      }
    }

    return index
  }

  init(): void {}

  onClear(): void {
    this.gold = 0
    this.deposit = 0
    this.withdraw = 0
    this.bonus = 0
    this.diamond = 0
    this.payed_ = false
  }

  onLoad(): void {}

  onDestroy(): void {}

  onPreloadData(): void {
    log('UserModule init')
  }

  hasBoundPhoneNum(): boolean {
    return this.phoneNum != ''
  }

  setProperty(
    gold: string,
    deposit: string,
    withdraw: string,
    bonus: string,
    diamond: string,
  ): void {
    this.gold = isNaN(Number(gold)) ? this.gold : this.formatFloat(gold)
    this.deposit = isNaN(Number(deposit)) ? this.deposit : this.formatFloat(deposit)
    this.withdraw = isNaN(Number(withdraw)) ? this.withdraw : this.formatFloat(withdraw)
    this.bonus = isNaN(Number(bonus)) ? this.bonus : this.formatFloat(bonus)
    this.diamond = isNaN(Number(diamond)) ? this.diamond : this.formatFloat(diamond)

    hall.eventDispatcher.emit(EventDefine.MoneyChange)
  }

  formatFloat(index: number | string): number {
    const num = Number(index)
    if (!Number.isInteger(num)) {
      return parseFloat(num.toFixed(2))
    }
    return num
  }

  postSendOtp(phoneNum: string): void {
    const data = {
      cid: base.channelId,
      uid: hall.userModule.userId,
      phone: phoneNum,
    }
    base.httpUtil
      .postJson(WebDefine.userOPTSendSG, data)
      .then((response) => {
        log('postSendOtp success:', response)
        if (response.code == 200) {
          hall.userModule.message_id = String(response.data.message_id)
          hall.eventDispatcher.emit(hall.EventDefine.SendOTPSuccess)
        } else {
          const errorMsg = webErrorMsg(response.code, response.msg)
          hall.eventDispatcher.emit(hall.EventDefine.SendOTPFail, errorMsg)
        }
      })
      .catch((_error: any) => {
        log('postConfigData error:', _error)
        const errorMsg = hall.Language.NetworkError
        hall.eventDispatcher.emit(hall.EventDefine.SendOTPFail, errorMsg)
      })
  }

  postVerify(optStr: string): void {
    const data = {
      cid: base.channelId,
      uid: hall.userModule.userId,
      message_id: hall.userModule.message_id,
      code: optStr,
    }
    base.httpUtil
      .postJson(WebDefine.userOPTVerifySend, data)
      .then((response) => {
        log('postBindPhone success:', response)
        if (response.code == 200) {
          hall.eventDispatcher.emit(hall.EventDefine.BindPhoneOk)
        } else {
          const errorMsg = webErrorMsg(response.code, response.msg)
          hall.eventDispatcher.emit(hall.EventDefine.BindPhoneFail, errorMsg)
        }
      })
      .catch((_error: any) => {
        log('postBindPhone error:', _error)
        const errorMsg = hall.Language.NetworkError
        hall.eventDispatcher.emit(hall.EventDefine.BindPhoneFail, errorMsg)
      })
  }

  postBindPhone(phoneNum: string, optStr: string): void {
    const data = {
      cid: base.channelId,
      uid: hall.userModule.userId,
      phone: phoneNum,
      code: optStr,
      message_id: hall.userModule.message_id,
    }
    base.httpUtil
      .postJson(WebDefine.bindPhone, data)
      .then((response) => {
        log('postBindPhone success:', response)
        if (response.code == 200) {
          hall.eventDispatcher.emit(hall.EventDefine.BindPhoneSuccess)
          hall.eventDispatcher.emit(hall.EventDefine.ChangeBindActivityRed)
          hall.registerModule.bindphoneFb('CompleteRegistration')
          if (globalThis.fbEvent) {
            globalThis.fbEvent('CompleteRegistration')
          }
        } else {
          const errorMsg = webErrorMsg(response.code, response.msg)
          hall.eventDispatcher.emit(hall.EventDefine.BindPhoneFail, errorMsg)
        }
      })
      .catch((error) => {
        log('postBindPhone error:', error)
        const errorMsg = hall.Language.NetworkError
        hall.eventDispatcher.emit(hall.EventDefine.BindPhoneFail, errorMsg)
      })
  }

  lastSendTime = 0 //上次刷新的时间
  sendClient2ProxyReqGetBalance() {
    const message = {
      UserID: hall.userModule.userId,
    }

    const secondsNow = FunctionUtils.stamp()
    if (this.lastSendTime == 0 || secondsNow - this.lastSendTime > 3.0) {
      wsClient.send(MsgIDs.Client2ProxyReqGetBalance, message)
      this.lastSendTime = secondsNow
    }
  }

  sendChagneNicknameReq(nick: string) {
    const message = {
      UserID: hall.userModule.userId,
      NewNickName: stringToBytes(nick),
    }
    wsClient.send(MsgIDs.Client2ProxyReqModifyNickName, message)
  }

  sendReqModifyPlayHead(icon: number) {
    const iconStr = '' + icon
    const message = {
      UserID: hall.userModule.userId,
      PlayHead: iconStr,
    }
    wsClient.send(MsgIDs.Client2ProxyReqModifyPlayHead, message)
  }

  inits2c(): void {
    ;(hall.s2c as any)['onClient2ProxyAckGetBalance'] = (msg: any) => {
      if (msg.Res == 0) {
        hall.userModule.setProperty(
          msg.ToalGold,
          msg.DepositGold,
          msg.CanWithDrawGold,
          msg.BonusGold,
          msg.DiamondGold,
        )
      } else {
        base.toast(serverErrorMsg(msg.Res))
      }
    }

    ;(hall.s2c as any)['onClient2ProxyAckModifyNickName'] = (
      msg: any,
    ) => {
      if (msg.Ret == 0) {
        this.userName = msg.NewNickName
        base.toast(hall.Language.modify_nickname_success)
      } else {
        base.toast(serverErrorMsg(msg.Ret))
      }
      hall.eventDispatcher.emit(hall.EventDefine.UserInfoChange)
    }

    ;(hall.s2c as any)['onClient2ProxyAckModifyPlayHead'] = (
      msg: any,
    ) => {
      if (msg.Ret == 0) {
        hall.userModule.userIcon = msg.PlayHead
        hall.eventDispatcher.emit(hall.EventDefine.UserInfoChange)
        base.toast(hall.Language.modify_user_icon_success)
      } else {
        base.toast(serverErrorMsg(msg.Ret))
      }
    }

    ;(hall.s2c as any)['onClient2ProxyPushGoldChange'] = (
      msg: any,
    ) => {
      log('onClient2ProxyPushGoldChange msgTbl.NewGold =', msg.NewGold)
      if (msg.NewGold == null || msg.NewGold == '') {
        return
      }
      hall.userModule.setProperty(
        msg.NewGold,
        msg.NewDeposit,
        msg.NewWithdraw,
        msg.NewBonus,
        msg.NewDiamond,
      )
    }

    ;(hall.s2c as any)['onClient2ProxyPushPayNotiy'] = (msg: any) => {
      const ret = msg.Res
      if (ret == 0) {
        base.toast(hall.Language.PayAmount + msg.Amount + hall.Language.Arrived)
        hall.userModule.setProperty(msg.Gold, msg.Deposit, msg.Withdraw, msg.Bonus, msg.Diamond)
        hall.vipEquityModule.requestVipEquity()
        hall.turnTableModule.postTurnInfo()
        hall.eventDispatcher.emit(hall.EventDefine.PaymentSuccessful)
      }
    }

    ;(hall.s2c as any)['onPushPlayerStatus'] = (msg: any) => {
      log('hall.s2c.onPushPlayerStatus Status =', msg.Status)
      hall.userModule.setPayed(msg.Status >= 1)
    }
  }

  setPayed(payed: any) {
    this.payed_ = payed
  }

  isPayed() {
    return this.payed_
  }
}
